export default {
	companyName: 'Affinity Kitchens',
	shortCompanyName: 'Affinity',
	badge: {
		label: 'A',
		color: '#e21d38'
	},
	addressing: {
		regions: [
			'Arizona',
			'California',
			'Hawaii',
			'New Mexico',
			'Utah'
		],
		cities: [
			'Apache Junction',
			'Avondale',
			'Benson',
			'Bisbee',
			'Buckeye',
			'Bullhead City',
			'Camp Verde',
			'Carefree',
			'Casa Grande',
			'Cave Creek',
			'Chandler',
			'Chino Valley',
			'Clarkdale',
			'Clifton',
			'Colorado City',
			'Coolidge',
			'Cottonwood',
			'Dewey-Humboldt',
			'Douglas',
			'Duncan',
			'Eager',
			'El Mirage',
			'Eloy',
			'Flagstaff',
			'Florence',
			'Fountain Hills',
			'Fredonia',
			'Gila Bend',
			'Gilbert',
			'Glendale',
			'Globe',
			'Gold Canyon',
			'Goodyear',
			'Guadalupe',
			'Hayden',
			'Holbrook',
			'Huachuca City',
			'Jerome',
			'Kearny',
			'Kingman',
			'Lake Havasu City',
			'Litchfield Park',
			'Mammoth',
			'Marana',
			'Mesa',
			'Miami',
			'New River',
			'Nogales',
			'Oro Valley',
			'Page',
			'Paradise Valley',
			'Parker',
			'Patagonia',
			'Payson',
			'Peoria - Maricopa County',
			'Peoria - Yavapai County',
			'Phoenix',
			'Pima',
			'Pine Top/Lakeside',
			'Prescott',
			'Prescott Valley',
			'Quartzsite',
			'Queen Creek - Maricopa County',
			'Queen Creek - Pinal County',
			'Rio Verde',
			'Safford',
			'Sahuarita',
			'Saint Johns',
			'San Luis',
			'Scottsdale',
			'Sedona - Coconino County',
			'Sedona - Yavapai County',
			'Show Low',
			'Sierra Vista',
			'Snowflake',
			'Somerton',
			'South Tuscon',
			'Springerville',
			'Star Valley',
			'Sun City',
			'Superior',
			'Surprise',
			'Taylor',
			'Tempe',
			'Thatcher',
			'Tolleson',
			'Tombstone',
			'Tucson',
			'Tucson - Pima County',
			'Tuyasan - Coconino County',
			'Wellton',
			'Wickenburg – Coconino County',
			'Wickenburg - Yavapai County',
			'Willcox',
			'Williams',
			'Winkleman - Gila County',
			'Winkleman – Pinal County',
			'Winslow',
			'Youngtown',
			'Yuma'
		]
	},
	fieldSettings: {
		inspection: {
			configVersion: 'v1',
			useBusinessSegement: false
		}
	},
	jobCostSettings: {
		publishOnReview: true,
		hideDesignRetainer: true,
		processingFee: 0.0125, // 1 1/4 % processing fee
		installation: {
			configVersion: 'v4',
			mode: 'complex',
			customUnits: [{
				label: 'Hour',
				value: 'Hour',
				defaultCost: 33.5
			}, {
				label: 'Unit',
				value: 'Unit',
				defaultCost: 0
			}, {
				label: 'Fixed',
				value: 'Fixed',
				defaultCost: 0
			}],
			sheets: {
				allowChanges: true,
				defaults: ['Pre-Install', 'Install', 'Post-Install']
			},
			unitPrice: {
				retail: 18.00,
				retailReno: 18.00,
				builder: 18.00,
				multifamily: 18.00
			}
		},
		glass: {
			laborCharge: 10.0
		},
		additionalServiceFee: {
			under1000: 0.155,
			under2500: 0.155,
			over2500: 0.155
		},
		setup: {
			editableSettings: {
				taxJurisdiction: {
					label: 'Tax Jurisdiction',
					type: 'select',
					dataAccessor: 'taxJurisdictions'
				},
				applyCondoPremium: {
					label: 'Condo Premium',
					type: 'boolean',
					defaultValue: '0'
				}
			}
		},
		workAreas: {
			defaultAreas: [
				'Kitchen',
				'Kitchen Perimeter',
				'Island',
				'Main Floor Half Bath',
				'Second Floor Half Bath',
				'Main Floor Main Bath',
				'Second Floor Main Bath',
				'Main Floor Master Bath',
				'Second Floor Master Bath',
				'Main Floor Mudroom',
				'Basement Mudroom',
				'Main Floor Laundry',
				'Second Floor Laundry',
				'Basement Laundry',
				'Basement Bath',
				'Main Floor Bar',
				'Second Floor Bar',
				'Basement Bar'
			]
		},
		specifications: {
			allowCustom: true,
			cabinetSpecVersions: {
				default: 'v1',
				affinityCustom: 'v1',
				allura: 'v7',
				crystalEncore: 'v1',
				crystalFramedCurrent: 'v1',
				crystalFramelessCurrent: 'v1',
				crystalKeyline: 'v1',
				greenCityCabinets: 'v1',
				hallmarkCabinet: 'v1',
				kitchenCraft: 'v7',
				nickelsCustomCabinets: 'v2',
				primaryKitchens: 'v1',
				zonavita: 'v6'
			},
			defaultAppliances: [
				'Refrigerator',
				'Freezer',
				'Range',
				'Rangetop',
				'Cooktop',
				'Hood Fan',
				'Chimney Hood',
				'Microwave Drawer',
				'Microwave',
				'Warming Drawer',
				'Coffee Maker',
				'OTR Microwave',
				'Beverage Fridge',
				'Wine Fridge',
				'Bar Fridge',
				'Single Wall Oven',
				'Double Wall Oven',
				'Steam Oven',
				'Wall Oven/Microwave Combination',
				'Dishwasher',
				'Dishwasher Drawer',
				'Fridge with panels',
				'Freezer with panels',
				'Dishwasher with panel',
				'Washing Machine',
				'Dryer',
				'Compactor'
			],
			workAreaSpecVersion: 'v1'
		},
		deliveryConfigVersion: 'v2',
		paymentTerms: {
			default: {
				name: 'Fifty/Fifty',
				canEdit: true,
				canAdd: true,
				minPercent: 0.0,
				payments: [{
					sortIndex: 0,
					percentDue: 0.5,
					description: 'Due Upon Signing'
				}, {
					sortIndex: 1,
					percentDue: 0.5,
					description: 'Due 5 Days Prior to Delivery'
				}]
			},
			tenPercentHoldback: {
				name: 'Ten Percent Holdback',
				canEdit: true,
				canAdd: true,
				minPercent: 0.0,
				payments: [{
					sortIndex: 0,
					percentDue: 0.5,
					description: 'Due Upon Signing'
				}, {
					sortIndex: 1,
					percentDue: 0.4,
					description: 'Due 5 Days Prior to Delivery'
				}, {
					sortIndex: 2,
					percentDue: 0.1,
					description: 'Due Upon Substantial Completion'
				}]
			},
			dueUponSigning: {
				name: 'Due Upon Signing',
				canEdit: false,
				canAdd: false,
				minPercent: 0.0,
				payments: [{
					sortIndex: 0,
					percentDue: 1.0,
					description: 'Due Upon Signing'
				}]
			},
			supplyOnly: {
				name: 'Supply Only',
				canEdit: true,
				canAdd: true,
				minPercent: 0.0,
				payments: [{
					sortIndex: 0,
					percentDue: 0.5,
					description: 'Due Upon Signing'
				}, {
					sortIndex: 1,
					percentDue: 0.5,
					description: 'Due 5 Days Prior to Delivery'
				}]
			}
		},
		proposal: {
			workAreaDetailsDefault: '(Cabinet Manufacturer): (Rough Lead Time)\nConstruction: (Ex: Frameless European box 5/8” melamine sides, top & bottoms)\nInteriors: (Ex: Maple Melamine)\nDrawers: (Ex: Solid wood dovetail, Blum tandem full extension, soft close guides)\nDoor Style, Wood Species, Finish Information:(Style, etc.)\n\nNotes: (Enter all details here)\n\nPrice: $0.00',
			termsDefault: '$(1,000) design retainer to begin drawings (applies towards your purchase)\n50% due upon signing of contract\n50% due upon delivery & installation'
		},
		scopeOfWork: {
			items: [{
				name: 'Installation'
			}, {
				name: 'Delivery of Cabinets'
			}]
		},
		workflow: {
			excludedKeys: [
				'sub-trades'
			],
			includedKeys: [
				'proposal',
				'pre-order'
			],
			excludedLineItemTypes: [
				'glass'
			]
		},
		referralFee: {
			paymentMethods: {
				check: 'Check',
				'gift-card': 'Gift Card'
			},
			subTypes: {
				formerClient: {
					label: 'Former Client',
					isPreSubtotal: true
				},
				architect: {
					label: 'Architect',
					isPreSubtotal: false
				},
				designer: {
					label: 'Designer',
					isPreSubtotal: false
				},
				contractor: {
					label: 'Contractor',
					isPreSubtotal: false
				}
			}
		},
		tax: {
			newHomeFactor: 0.65,
			jurisdictions: [{
				name: 'Anthem',
				rate: 0.063
			}, {
				name: 'Apache County',
				rate: 0.061
			}, {
				name: 'Apache Junction (Maricopa)',
				rate: 0.087
			}, {
				name: 'Avondale',
				rate: 0.088
			}, {
				name: 'Benson',
				rate: 0.101
			}, {
				name: 'Bisbee',
				rate: 0.096
			}, {
				name: 'Buckeye',
				rate: 0.093
			}, {
				name: 'Bullhead City',
				rate: 0.0760
			}, {
				name: 'Camp Verde',
				rate: 0.1
			}, {
				name: 'Carefree',
				rate: 0.103
			}, {
				name: 'Casa Grande',
				rate: 0.107
			}, {
				name: 'Cave Creek',
				rate: 0.113
			}, {
				name: 'Chandler',
				rate: 0.078
			}, {
				name: 'Chino Valley',
				rate: 0.1035
			}, {
				name: 'Clarkdale',
				rate: 0.1085
			}, {
				name: 'Clifton',
				rate: 0.0910
			}, {
				name: 'Cochise County',
				rate: 0.061
			}, {
				name: 'Coconino County',
				rate: 0.069
			}, {
				name: 'Colorado City',
				rate: 0.0760
			}, {
				name: 'Coolidge',
				rate: 0.107
			}, {
				name: 'Cottonwood',
				rate: 0.1085
			}, {
				name: 'Dewey-Humboldt',
				rate: 0.0835
			}, {
				name: 'Douglas',
				rate: 0.099
			}, {
				name: 'Duncan',
				rate: 0.0810
			}, {
				name: 'Eager',
				rate: 0.091
			}, {
				name: 'El Mirage',
				rate: 0.093
			}, {
				name: 'Eloy',
				rate: 0.112
			}, {
				name: 'Flagstaff',
				rate: 0.09386
			}, {
				name: 'Florence',
				rate: 0.107
			}, {
				name: 'Fountain Hills',
				rate: 0.0920
			}, {
				name: 'Fredonia',
				rate: 0.109
			}, {
				name: 'Gila Bend',
				rate: 0.0980
			}, {
				name: 'Gila County',
				rate: 0.066
			}, {
				name: 'Gilbert',
				rate: 0.083
			}, {
				name: 'Glendale',
				rate: 0.092
			}, {
				name: 'Globe',
				rate: 0.0990
			}, {
				name: 'Gold Canyon (Pinal County)',
				rate: 0.067
			}, {
				name: 'Goodyear',
				rate: 0.098
			}, {
				name: 'Graham County',
				rate: 0.066
			}, {
				name: 'Greenlee County',
				rate: 0.061
			}, {
				name: 'Guadalupe',
				rate: 0.103
			}, {
				name: 'Hayden',
				rate: 0.0960
			}, {
				name: 'Holbrook',
				rate: 0.0943
			}, {
				name: 'Huachuca City',
				rate: 0.08
			}, {
				name: 'Jerome',
				rate: 0.0935
			}, {
				name: 'Kearny',
				rate: 0.107
			}, {
				name: 'Kingman',
				rate: 0.0810
			}, {
				name: 'La Paz County',
				rate: 0.066
			}, {
				name: 'Lake Havasu City',
				rate: 0.0760
			}, {
				name: 'Litchfield Park',
				rate: 0.111
			}, {
				name: 'Mammoth',
				rate: 0.107
			}, {
				name: 'Marana - Pima County',
				rate: 0.101
			}, {
				name: 'Marana - Pinal County',
				rate: 0.107
			}, {
				name: 'Maricopa County',
				rate: 0.063
			}, {
				name: 'Maricopa Pinal County',
				rate: 0.102
			}, {
				name: 'Mesa',
				rate: 0.0830
			}, {
				name: 'Miami',
				rate: 0.0910
			}, {
				name: 'Mohave County',
				rate: 0.056
			}, {
				name: 'Navajo County',
				rate: 0.0643
			}, {
				name: 'New River',
				rate: 0.063
			}, {
				name: 'Nogales',
				rate: 0.086
			}, {
				name: 'Oro Valley',
				rate: 0.101
			}, {
				name: 'Out of State',
				rate: 0.0,
				outOfStateOnly: true
			}, {
				name: 'Page',
				rate: 0.0990
			}, {
				name: 'Paradise Valley',
				rate: 0.088
			}, {
				name: 'Parker',
				rate: 0.0860
			}, {
				name: 'Patagonia',
				rate: 0.096
			}, {
				name: 'Payson',
				rate: 0.1048
			}, {
				name: 'Peoria - Maricopa County',
				rate: 0.081
			}, {
				name: 'Peoria - Yavapai County',
				rate: 0.0815
			}, {
				name: 'Phoenix',
				rate: 0.091
			}, {
				name: 'Pima',
				rate: 0.0960
			}, {
				name: 'Pima County',
				rate: 0.061
			}, {
				name: 'Pinal County',
				rate: 0.067
			}, {
				name: 'Pine Top/Lakeside',
				rate: 0.0943
			}, {
				name: 'Prescott',
				rate: 0.093
			}, {
				name: 'Prescott Valley',
				rate: 0.0873
			}, {
				name: 'Quartzsite',
				rate: 0.1010
			}, {
				name: 'Queen Creek - Maricopa County',
				rate: 0.1055
			}, {
				name: 'Queen Creek - Pinal County',
				rate: 0.1095
			}, {
				name: 'Rio Verde',
				rate: 0.063
			}, {
				name: 'Safford',
				rate: 0.0910
			}, {
				name: 'Sahuarita',
				rate: 0.101
			}, {
				name: 'Saint Johns', //out of sequence?
				rate: 0.091
			}, {
				name: 'San Luis',
				rate: 0.10712
			}, {
				name: 'Santa Cruz County',
				rate: 0.066
			}, {
				name: 'Scottsdale',
				rate: 0.08,
				supplyOnlyJurisdiction: 'affinity-kitchens'
			}, {
				name: 'Scottsdale 85254',
				rate: 0.091
			}, {
				name: 'Sedona - Coconino County',
				rate: 0.1040
			}, {
				name: 'Sedona - Yavapai County',
				rate: 0.0985
			}, {
				name: 'Show Low',
				rate: 0.0843
			}, {
				name: 'Sierra Vista',
				rate: 0.0805
			}, {
				name: 'Snowflake',
				rate: 0.0943
			}, {
				name: 'Somerton',
				rate: 0.10012
			}, {
				name: 'South Tuscon',
				rate: 0.116
			}, {
				name: 'Springerville',
				rate: 0.091
			}, {
				name: 'Star Valley',
				rate: 0.0860
			}, {
				name: 'Sun City',
				rate: 0.063
			}, {
				name: 'Superior',
				rate: 0.107
			}, {
				name: 'Surprise',
				rate: 0.1
			}, {
				name: 'Tax Exempt (Form 5005)',
				rate: 0.0,
				requiresTaxExemptContractor: true
			}, {
				name: 'Taylor',
				rate: 0.09430
			}, {
				name: 'Tempe',
				rate: 0.081
			}, {
				name: 'Thatcher',
				rate: 0.1010
			}, {
				name: 'Tolleson',
				rate: 0.088
			}, {
				name: 'Tombstone',
				rate: 0.096
			}, {
				name: 'Tucson',
				rate: 0.087
			}, {
				name: 'Tucson - Pima County',
				rate: 0.061,
				supplyOnlyJurisdiction: 'tucson'
			}, {
				name: 'Tuyasan - Coconino County',
				rate: 0.0890
			}, {
				name: 'Wellton',
				rate: 0.10212
			}, {
				name: 'Wickenburg – Maricopa County',
				rate: 0.0980
			}, {
				name: 'Wickenburg - Yavapai County',
				rate: 0.0985
			}, {
				name: 'Willcox',
				rate: 0.091
			}, {
				name: 'Williams',
				rate: 0.104
			}, {
				name: 'Winkleman - Gila County',
				rate: 0.101
			}, {
				name: 'Winkleman – Pinal County',
				rate: 0.1020
			}, {
				name: 'Winslow',
				rate: 0.09430
			}, {
				name: 'Yavapai County',
				rate: 0.0635
			}, {
				name: 'Youngtown',
				rate: 0.093
			}, {
				name: 'Yuma',
				rate: 0.08412
			}, {
				name: 'Yuma County',
				rate: 0.06712
			}, {
				name: 'Out of State Custom',
				outOfStateOnly: true,
				custom: true
			}]
		}
	},
	search: {
		params: {
			default: [{
				key: 'relayNumber',
				name: 'Relay No.',
				searchTextTest: '^(JC|J|CO)-\\d+$'
			}, {
				key: 'accountingId',
				nameKey: ['Accounting ID', 'job']
			}, {
				key: 'address',
				name: 'Address'
			}, {
				key: 'client',
				name: 'Client Name'
			}, {
				key: 'contact',
				name: 'Contact Name'
			}, {
				key: 'phone',
				name: 'Phone Number',
				searchTextTest: 'validator.isPhone'
			}, {
				key: 'accountManager',
				name: 'Designer Name'
			}, {
				key: 'builderName',
				name: 'Builder Name'
			}],
			'scan-management-jobs-search': [{
				key: 'accountingId',
				nameKey: ['Accounting ID', 'job'],
				searchTextTest: '^\\d{6}(\\.\\d{2})?$'
			}]
		}
	},
	systemRoleEmployeeTitleTests: {
		coordinator: ['coordinator-customer-service'],
		designer: ['designer', 'order-processing-manager'],
		processor: ['processor', 'lead-processor']
	},
	localization: {
		locale: 'en-us',
		strings: {
			Cheque: 'Check',
			Province: 'State',
			'Postal Code': 'Zip Code',
			'Ret-H': 'New Home Sold to Client',
			'Ret-C': 'New Home Sold to Builder',
			'Ren-H': 'Remodel Sold to Client',
			'Ren-C': 'Remodel Sold to Contractor',
			'Ren-L': 'Affinity managed Remodel'
		}
	},
	variants: {
		tucson: {
			companyName: 'Affinity Kitchens Tucson',
			shortCompanyName: 'Tucson',
			badge: {
				label: 'T',
				color: '#000000'
			}
		}
	}
};